import { deleteApplicationContainer } from "services/requests/v1/container";

import ModalContentLayout from "components/generic/modal-content-layout.component";

import { useAppsContainerTabContext } from "storage/context/apps-container-tab-context";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/pro-light-svg-icons";
import { useTranslation } from "utils/hooks/use-translation.hook";

type Props = {
    closeModalFn: () => void;
    updateData: () => Promise<void>;
};

const DeleteContainersModalContent = ({ closeModalFn, updateData }: Props) => {
    const translate = useTranslation();

    const {
        containers,
        editModalGroupName,
        containerId,
        editMode,
        setError,
        subscribeContent,
        unsubscribeContent,
    } = useAppsContainerTabContext();

    const deleteGroup = async () => {
        const contentName = "delete-groups";

        try {
            subscribeContent(contentName);

            await Promise.all(
                containers[editModalGroupName].map(async ({ id }) => {
                    await deleteApplicationContainer(id);
                })
            );

            await updateData();
            unsubscribeContent(contentName, true);
        } catch (error) {
            setError(contentName);
        }
    };

    const deleteSubGroup = async () => {
        if (!containerId) return;
        const contentName = "delete-subgroups";

        try {
            subscribeContent(contentName);

            await deleteApplicationContainer(containerId);
            await updateData();
            unsubscribeContent(contentName, true);
        } catch (error) {
            setError(contentName);
        }
    };

    const handleDelete = async () => {
        editMode === "group" ? deleteGroup() : deleteSubGroup();
        closeModalFn();
    };

    return (
        <ModalContentLayout
            firstButtonStatus="enabled"
            secondButtonStatus={"enabled"}
            firstButtonTitle={translate("app.gis.cancel")}
            secondButtonTitle={translate("app.Components.warning.delete")}
            onFirstButtonClick={closeModalFn}
            onSecondButtonClick={handleDelete}
        >
            <div className="c-confirmation-modal">
                <FontAwesomeIcon
                    className="c-confirmation-modal__icon"
                    icon={faExclamationTriangle}
                />
                <div className="c-confirmation-modal__message-container">
                    <span className="c-confirmation-modal__message">
                        {translate("app.hierarchy.confirm_delete_group_title")}
                    </span>
                </div>
            </div>
        </ModalContentLayout>
    );
};

export default DeleteContainersModalContent;
